import { getInfo } from '@/api/system/rbac';
import {getConfirmDelegator} from '@/api/nominee/general';

export default {
    namespaced: true,
    state: {
        info: {},
        confirmDelegator: true,
    },
    getters: {
        permissions(state) {
            const result = {};
            (state.info.permissions || []).forEach((element) => {
                result[element.permission] = element.actions;
            });
            return result;
        },
        getCurrentUserInfo(state) {
            return state.info.uid;
        },
        getConfirmDelegator(state) {
            return state.confirmDelegator;
        }
    },
    actions: {
        async getInfo({ commit }) {
            try {
                const result = await getInfo();
                // result.permissions.push({actions : ["query"],permission:"delegation"})
                // console.log(result);
                commit('setUserInfo', result);
                return result;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        async getConfirmDelegator({ commit }) {
            try {
                const result = await getConfirmDelegator();
                commit('setConfirmDelegator', result);
                return result;
            } catch (error) {
                console.log(error);
                throw error;
            }
        }
    },
    mutations: {
        setUserInfo(state, data) {
            state.info = data;
        },
        setConfirmDelegator(state, data) {
            state.confirmDelegator = data;
        }
    }
};
